import axios from 'axios';

/**
 * Downloads a file using axios to include authentication headers.
 * 
 * @param {string} url - The URL to download from
 * @param {string} fileName - The name of the file to be saved as
 * @returns {Promise} - Resolves when the download is initiated
 */
export const downloadAuthenticatedFile = async (url, fileName) => {
    try {
        const response = await axios.get(url, {
            responseType: 'blob'
        });

        // Create a blob URL
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        
        // Create a temporary link element
        const link = document.body.appendChild(document.createElement('a'));
        link.href = blobUrl;
        link.setAttribute('download', fileName);
        
        // Trigger click and cleanup
        link.click();
        
        // Small timeout to ensure download started in some browsers
        setTimeout(() => {
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
        }, 100);

        return { success: true };
    } catch (error) {
        console.error('Error downloading file:', error);
        throw error;
    }
};
